module.exports = __webpack_public_path__ + "img/22_37.da981fa6.png";